import { html, View } from 'rune-ts';
import { CoverBanner } from '../../../../components/atoms/CoverBanner/CoverBanner';
import klass from './ProductRankingCoverBanner.module.scss';
import { font } from '../../../../../shared/typography';
import { IntervalTimer } from '@services/MarppleShop/shared/util/timer';

export type ProductRankingCoverBannerViewData = {
  is_mobile: boolean;
  last_updated_at: Date | null;
};

class LastUpdatedAtView extends View<{
  updated_at: Date;
}> {
  protected override template() {
    return this.data.updated_at
      ? html`<span class="${klass.update} ${font('12_medium')}">
          <span>${CoverBanner.formatDiffDate(this.data.updated_at)} ${ET('mps2::common::update')}</span>
        </span>`
      : html``;
  }
}

export class ProductRankingCoverBannerView extends View<ProductRankingCoverBannerViewData> {
  private readonly lastUpdatedAtView: LastUpdatedAtView | null = null;
  private readonly intervalTimer: IntervalTimer;

  constructor(data: ProductRankingCoverBannerViewData) {
    super(data);

    if (data.last_updated_at) {
      this.lastUpdatedAtView = new LastUpdatedAtView({
        updated_at: data.last_updated_at,
      });
    }

    this.intervalTimer = new IntervalTimer(1000, {
      onTick: () => {
        if (this.lastUpdatedAtView) {
          this.lastUpdatedAtView.redraw();
        }
      },
    });
  }

  protected override template() {
    return this.data.is_mobile ? this.mobileTemplate() : this.pcTemplate();
  }

  private static readonly KeyVisual = CoverBanner.resizeImage(
    '//s3.marpple.co/files/u_2232571/2025/3/original/4c87d297d6c5bea32d6b3d9bf3d47b46bbbb59c21.png',
  );

  private pcTemplate() {
    return html`<div class="${klass.banner}">
      <span class="${klass.title_wrap}">
        <span class="${CoverBanner.typo.pc}">RANKING</span>
        <img alt="" class="${klass.key_visual}" src="${ProductRankingCoverBannerView.KeyVisual}" />
        <span class="${CoverBanner.typo.pc} ${klass.title}">TOP 100</span>
      </span>
      <span class="${klass.right}">${this.lastUpdatedAtView ?? ''}</span>
    </div>`;
  }

  private mobileTemplate() {
    return html`<div class="${klass.banner}">
      <span class="${klass.title_wrap}">
        <span class="${CoverBanner.typo.mobile}">${CoverBanner.toText('RANKING\nTOP100')}</span>
        <img alt="" class="${klass.key_visual}" src="${ProductRankingCoverBannerView.KeyVisual}" />
      </span>
      <span class="${klass.right}">${this.lastUpdatedAtView ?? ''}</span>
    </div>`;
  }

  setUpdatedAt(date: Date | null) {
    this.data.last_updated_at = date;
  }

  protected override onRender() {
    super.onRender();

    if (this.lastUpdatedAtView) {
      this.intervalTimer.start();
    }
  }

  protected override onUnmount(): void {
    super.onUnmount();

    this.intervalTimer.clear();
  }
}
